var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45024 17.25C2.34888 17.4681 1.58606 18.521 1.68679 19.684C1.78753 20.8471 2.71896 21.7408 3.84 21.75H19.2C19.8127 21.765 20.4013 21.501 20.8118 21.027C21.1636 20.6032 21.3548 20.0602 21.3494 19.5C21.4022 18.3931 20.6454 17.4229 19.5946 17.25L3.45024 17.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.392 16.2499C19.6205 16.2505 19.8177 16.0831 19.8634 15.8499L21.0154 9.73995C22.0499 9.67713 22.8969 8.86003 23.0363 7.79037C23.1757 6.72071 22.5685 5.69798 21.5874 5.35015C20.6064 5.00232 19.5263 5.42679 19.0103 6.36292C18.4943 7.29905 18.6868 8.48474 19.4698 9.19195L17.1418 11.9589C17.052 12.0657 16.9228 12.1277 16.7866 12.1294C16.6503 12.1311 16.5198 12.0724 16.4275 11.9679L12.5309 7.53895C13.6943 7.03664 14.355 5.7483 14.1092 4.46171C13.8634 3.17512 12.7794 2.24854 11.52 2.24854C10.2606 2.24854 9.17663 3.17512 8.93079 4.46171C8.68495 5.7483 9.34575 7.03664 10.5091 7.53895L6.624 11.9539C6.53117 12.0594 6.39941 12.1184 6.26208 12.1159C6.12495 12.1136 5.99532 12.0503 5.90592 11.9419L3.60768 9.15795C4.36989 8.43406 4.53287 7.24911 3.99645 6.33141C3.46002 5.41371 2.37459 5.02057 1.40731 5.39363C0.440034 5.76669 -0.137894 6.80136 0.0287514 7.86167C0.195397 8.92198 1.05989 9.71066 2.09088 9.74295L3.19584 15.8429C3.23872 16.0789 3.43663 16.2498 3.6672 16.2499H19.392Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.3e3cae4b.svg";
export { ForwardRef as ReactComponent };